import React, { useContext } from 'react'
import { Toolbar, Select, IconButton, DialogContent, Dialog, InputLabel,
FormControl, AppBar, AccordionDetails, AccordionSummary, Accordion} from '@mui/material'
import { ExpandMore, Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux'
import { UserContext } from 'account'
import { app } from 'common/ducks/index'
import styled from 'styled-components'
import theme from 'styles/theme'

function Settings({ onClose = () => {}, show = false }) {
  const currentUser = useContext(UserContext)
  const dispatch = useDispatch()
  const selectedUser = useSelector((state) => state.app.viewDataAs)

  const userAccessList = currentUser?.hasAccessTo || []

  function handleChange(event) {
    const { value } = event.target

    dispatch(app.actions.changeViewDataAs(value))
  }

  return (
    <Settings.Dialog fullScreen open={show} onClose={onClose}>
      <form>
        <Settings.AppBar color="default">
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClose}>
              <Close />
            </IconButton>
            <Settings.Title>Settings</Settings.Title>
          </Toolbar>
        </Settings.AppBar>

        <Settings.Content>
          <Accordion expanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
              Preferences
            </AccordionSummary>
            <AccordionDetails>
              <FormControl fullWidth variant="outlined">
                <InputLabel>View data as...</InputLabel>
                <Select
                  label="View data as..."
                  native
                  onChange={handleChange}
                  value={selectedUser}
                >
                  <option value="self">myself</option>
                  {userAccessList?.map((access) => (
                    <option key={access.granter} value={access.granter}>
                      {access.granter}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </AccordionDetails>
          </Accordion>
        </Settings.Content>
      </form>
    </Settings.Dialog>
  )
}

Settings.AppBar = styled(AppBar)`
  padding-top: env(safe-area-inset-top);
  position: static;
`
Settings.Content = styled(DialogContent)`
  margin-top: calc(env(safe-area-inset-top) + 56px);
  padding: 0 !important;
`
Settings.Dialog = styled(Dialog)`
  padding-bottom: env(safe-area-inset-bottom);
`
Settings.Title = styled.h3`
  flex: 1;
  margin-bottom: 0;
  margin-left: ${theme.spacing(2)}px;
`

export default Settings
